'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = require('react-dom');

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LISTENER_CAPTURE_TRUE = {
    capture: true
};

var LISTENER_CAPTURE_FALSE = {
    capture: true
};

var PopupPanelMouseManager = function (_React$Component) {
    _inherits(PopupPanelMouseManager, _React$Component);

    function PopupPanelMouseManager() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PopupPanelMouseManager);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopupPanelMouseManager.__proto__ || Object.getPrototypeOf(PopupPanelMouseManager)).call.apply(_ref, [this].concat(args))), _this), _this.attachListener = function () {
            var _this$props = _this.props,
                duration = _this$props.duration,
                stayOpen = _this$props.stayOpen;


            if (stayOpen) return;

            (0, _lodash.defer)(function () {
                document.addEventListener('click', _this.checkTargetContained, LISTENER_CAPTURE_TRUE);
                document.addEventListener('click', _this.closePopup, LISTENER_CAPTURE_FALSE);
            });

            if (duration) {
                _this.delayedHide = (0, _lodash.delay)(_this.closePopup, duration);
            }
        }, _this.removeListener = function () {
            var stayOpen = _this.props.stayOpen;

            if (stayOpen) return;

            document.removeEventListener('click', _this.checkTargetContained, LISTENER_CAPTURE_TRUE);
            document.removeEventListener('click', _this.closePopup, LISTENER_CAPTURE_FALSE);

            if (_this.delayedHide) {
                clearTimeout(_this.delayedHide);
                _this.delayedHide = null;
            }
        }, _this.checkTargetContained = function (event) {
            var popup = (0, _reactDom.findDOMNode)(_this);
            _this.targetContained = popup.contains(event.target);
        }, _this.closePopup = function (event) {
            // check if the target _was_ a child of the popup
            if (_this.targetContained) return;

            // if not, close the popup.
            // deferred to not interfer with popup button toggle events
            var closePopup = _this.props.closePopup;

            (0, _lodash.defer)(closePopup);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PopupPanelMouseManager, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var visible = this.props.visible;


            if (visible) {
                this.attachListener();
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var _props = this.props,
                visible = _props.visible,
                onClose = _props.onClose;


            if (!visible && nextProps.visible) {
                this.attachListener();
            }

            if (visible && !nextProps.visible) {
                this.removeListener();
                onClose && onClose();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            var onClose = this.props.onClose;

            this.removeListener();
            onClose && onClose();
        }

        // check if the click target is outside the popup _before_ making any state updates,
        // this is because there are a number of instances where the button will disapper after updating the state


        // after updating the state,

    }, {
        key: 'render',
        value: function render() {
            return this.props.children;
        }
    }]);

    return PopupPanelMouseManager;
}(_react2.default.Component);

PopupPanelMouseManager.propTypes = {
    closePopup: _propTypes2.default.func.isRequired,
    visible: _propTypes2.default.bool,
    stayOpen: _propTypes2.default.bool,
    duration: _propTypes2.default.number,
    onClose: _propTypes2.default.func,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
};

exports.default = PopupPanelMouseManager;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/popupPanel/PopupPanelMouseManager.js
// module id = 1926
// module chunks = 0